import React, { useEffect, useState } from "react";
import AppWrapper from "../AppWrapper";
import {
  DropZone,
  FormLayout,
  Page,
  Select,
  TextField,
  Button,
  Checkbox,
} from "@shopify/polaris";
import { SearchIcon } from "@shopify/polaris-icons";
import supabase from "../../supabase-client";
import moment from "moment";

function NewPolicy() {
  const [providers, setProviders] = useState(undefined);
  const [policy, setPolicy] = useState({
    periodicity: "quarterly",
    is_temporary: false,
  });
  const [carQuery, setCarQuery] = useState("");
  const [car, setCar] = useState(undefined);
  const [isSearching, setIsSearching] = useState(false);
  const [didFindCar, setDidFindCar] = useState(undefined);
  const [file, setFile] = useState(undefined);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = (value, id) => {
    if (id === "validity_from") {
      const validity_to = moment(value).add(1, "year").format("YYYY-MM-DD");
      setPolicy({ ...policy, validity_from: value, validity_to });
      return;
    }
    if (id === "provider") {
      setPolicy({
        ...policy,
        [id]: value,
        custom_fields: {},
        shared_charges: {},
        per_payment_charges: {},
        is_temporary: false,
      });
      return;
    }
    if (id === "is_temporary") {
      setPolicy({ [id]: value === "true", provider: policy.provider });
      return;
    }
    setPolicy({ ...policy, [id]: value });
  };

  const handleFileUpload = (file) => {
    setFile(file);
  };

  const periodicity = [
    { value: "monthly", label: "Mensual" },
    { value: "quarterly", label: "Trimestral" },
    { value: "semiannual", label: "Semestral" },
    { value: "annual", label: "Anual" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await supabase
        .from("insurance_providers")
        .select("value:id, label:name");
      if (error) {
        console.error(error);
        return;
      }
      if (data.length === 1) setPolicy({ ...policy, provider: data[0].value });
      setProviders(data);
    };
    if (!providers) fetchData();
  }, []);

  const handleCarQueryChange = (value) => {
    setCar(undefined);
    setCarQuery(value.toUpperCase());
  };

  const searchCar = async (e) => {
    e.preventDefault();
    setIsSearching(true);
    const colToSearch = carQuery.length < 8 ? "plate" : "vin";
    const { data, error } = await supabase
      .from("cars")
      .select("id, plate, vin, model(name)")
      .eq(colToSearch, carQuery)
      .single();
    if (error) {
      setDidFindCar(false);
      setIsSearching(false);
      return;
    }
    setCar(data);
    setCarQuery(`${data.model.name} ${data.plate || ""}`.trim());
    setDidFindCar(true);
    setIsSearching(false);
  };

  const handleSave = async () => {
    setIsSaving(true);
    const policyObject = { ...policy, car: car.id };

    const { data, error } = await supabase
      .from("insurance")
      .insert(policyObject)
      .select("id, document")
      .single();
    if (error) {
      console.error(error);
      setIsSaving(false);
      return;
    }
    const { error: fileError } = await supabase.storage
      .from("polizas")
      .upload(`${data.document}.pdf`, file);
    if (fileError) {
      console.error(fileError);
      setIsSaving(false);
      return;
    }
    window.location.reload();
  };

  const saveButton = () => {
    let canSave =
      car &&
      file &&
      policy.provider &&
      policy.policy_no &&
      policy.validity_from &&
      policy.validity_to &&
      policy.emission_date &&
      policy.net_premium;
    if (policy.is_temporary) {
      canSave =
        car &&
        file &&
        policy.provider &&
        policy.validity_from &&
        policy.validity_to &&
        policy.emission_date;
    }
    return {
      content: "Guardar",
      onAction: handleSave,
      disabled: !canSave,
      loading: isSaving,
    };
  };

  const customFields = () => {
    const handleCustomFields = (value, id) => {
      setPolicy({
        ...policy,
        custom_fields: { ...policy.custom_fields, [id]: value },
      });
    };
    const handleSharedFields = (value, id) => {
      setPolicy({
        ...policy,
        shared_charges: { ...policy.shared_charges, [id]: value },
      });
    };
    const handlePerPayFields = (value, id) => {
      setPolicy({
        ...policy,
        per_payment_charges: { ...policy.per_payment_charges, [id]: value },
      });
    };
    if (policy.provider === 1) {
      return (
        <>
          <FormLayout.Group title="Info Adicional (Sura)">
            <TextField
              label="Oficina"
              type="number"
              onChange={handleCustomFields}
              id="oficina"
              value={policy.custom_fields?.oficina}
            />
            <TextField
              label="Ramo"
              type="number"
              onChange={handleCustomFields}
              id="ramo"
              value={policy.custom_fields?.ramo}
            />
          </FormLayout.Group>
          <FormLayout.Group title="Cargos">
            <TextField
              label="Prima Neta"
              type="number"
              prefix="$"
              id="net_premium"
              onChange={handleChange}
              value={policy.net_premium}
            />
            <TextField
              label="Financiamiento"
              type="number"
              prefix="$"
              id="Financiamiento"
              onChange={handleSharedFields}
              value={policy.shared_charges?.Financiamiento}
            />
            <TextField
              label="Gasto de Expedición"
              type="number"
              prefix="$"
              id="Gasto_de_Expedicion"
              onChange={handlePerPayFields}
              value={policy.per_payment_charges?.Gasto_de_Expedicion}
            />
          </FormLayout.Group>
        </>
      );
    }
  };

  return (
    <AppWrapper>
      <Page title="Nueva Poliza" primaryAction={saveButton()}>
        <FormLayout>
          <FormLayout.Group>
            <form onSubmit={searchCar}>
              <div style={{ display: "flex", gap: "0.25rem" }}>
                <span style={{ flexGrow: 1 }}>
                  <TextField
                    label={car ? "Vehiculo ✅" : "Vehiculo"}
                    autoComplete="off"
                    placeholder="Buscar por placa o VIN"
                    value={carQuery}
                    onChange={handleCarQueryChange}
                    error={didFindCar === false}
                    readOnly={car}
                    clearButton
                    onClearButtonClick={() => {
                      setCarQuery("");
                      setCar(undefined);
                      setDidFindCar(undefined);
                    }}
                  />
                </span>
                <span
                  style={{
                    aspectRatio: 1,
                    display: "flex",
                    alignItems: "center",
                    marginTop: "auto",
                    width: 32,
                    height: 32,
                  }}
                >
                  <Button
                    icon={SearchIcon}
                    submit
                    disabled={carQuery === "" || car}
                    loading={isSearching}
                  />
                </span>
              </div>
            </form>
            <Select
              label="Aseguradora"
              options={providers}
              id="provider"
              onChange={handleChange}
              value={policy.provider}
            />
            <Select
              label="Carta Cobertura"
              options={[
                { value: false, label: "No" },
                { value: true, label: "Si" },
              ]}
              id="is_temporary"
              onChange={handleChange}
              value={policy.is_temporary}
            />
            <TextField
              label="No. de Poliza"
              id="policy_no"
              onChange={handleChange}
              value={policy.policy_no}
              autoComplete="off"
              disabled={policy.is_temporary}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Vigencia Desde"
              type="date"
              id="validity_from"
              onChange={handleChange}
              value={policy.validity_from}
            />
            <TextField
              label="Vigencia Hasta"
              type="date"
              id="validity_to"
              onChange={handleChange}
              value={policy.validity_to}
            />
            <Select
              label="Periodicidad"
              options={periodicity}
              value={policy.periodicity}
              onChange={handleChange}
              id="periodicity"
              disabled={policy.is_temporary}
            />
            <TextField
              label="Emision"
              type="date"
              id="emission_date"
              onChange={handleChange}
              value={policy.emission_date}
            />
          </FormLayout.Group>
          <DropZone
            label="Poliza"
            accept={"application/pdf"}
            onDropAccepted={(file) => handleFileUpload(file[0])}
          >
            <DropZone.FileUpload
              actionTitle="Cargar PDF"
              actionHint={
                file ? `${file.name} ✅` : "Sube la poliza en formato PDF."
              }
            />
          </DropZone>
          {!policy.is_temporary && customFields()}
          <FormLayout.Group>
            <TextField
              id="notes"
              value={policy.notes}
              onChange={handleChange}
              multiline={4}
              label="Notas"
            />
          </FormLayout.Group>
        </FormLayout>
      </Page>
    </AppWrapper>
  );
}

export default NewPolicy;
